import { ArrowWrapperDefault, ArrowWrapperSimilarRooms } from './styled-components';

export const ARROW_WRAPPER_TYPE = {
  default: ArrowWrapperDefault,
  similarRooms: ArrowWrapperSimilarRooms,
};
